import type { FC } from "react";
import { Info } from "lucide-react";
import { Card } from "@ui/Card";
import { cn } from "@/utils/tailwind";

interface InfoCardProps {
  className?: string;
  text: string;
}

export const InfoCard: FC<InfoCardProps> = ({ className, text }) => {
  return (
    <Card
      className={cn(
        "bg-background flex w-full! flex-row gap-2 p-4! text-sm sm:items-center sm:gap-4 sm:text-base",
        className,
      )}
    >
      <Info className="mt-1 size-[13px] shrink-0 sm:mt-0 sm:size-6" strokeWidth={1.5} />
      <p className="leading-[22.4px] sm:leading-[140%]">{text}</p>
    </Card>
  );
};
